import React from 'react'
import { motion } from 'framer-motion'
import { Shield, Lock, Eye, Database, Bell, Trash2 } from 'lucide-react'

const PrivacyPage = () => {
  return (
    <div className="max-w-3xl mx-auto">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-8">
        <div className="w-16 h-16 bg-primary-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <Shield size={32} className="text-primary-600" />
        </div>
        <h1 className="section-title">隐私政策</h1>
        <p className="section-subtitle">我们高度重视您的个人信息安全</p>
      </motion.div>

      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="card p-6 md:p-8 space-y-8">
        <section>
          <div className="flex items-center mb-3">
            <Database size={20} className="text-primary-600 mr-2" />
            <h2 className="text-lg font-bold text-gray-900">信息收集</h2>
          </div>
          <p className="text-gray-600 leading-relaxed">
            我们收集您的姓名、联系方式、教育背景、简历等信息，仅用于提供求职匹配服务。
            涉及家庭背景、住址等敏感信息时，我们会明确告知并征得您的同意。
          </p>
        </section>

        <section>
          <div className="flex items-center mb-3">
            <Lock size={20} className="text-primary-600 mr-2" />
            <h2 className="text-lg font-bold text-gray-900">数据安全</h2>
          </div>
          <p className="text-gray-600 leading-relaxed">
            所有敏感数据采用AES-256加密存储，加密密钥与服务端分离管理，不硬编码在代码中。
            密钥定期轮换（90天/次），确保数据安全。
          </p>
        </section>

        <section>
          <div className="flex items-center mb-3">
            <Eye size={20} className="text-primary-600 mr-2" />
            <h2 className="text-lg font-bold text-gray-900">信息使用</h2>
          </div>
          <p className="text-gray-600 leading-relaxed">
            您的信息仅用于求职匹配分析，不会出售或共享给第三方。
            匹配结果仅供参考，不作为录取保证。
          </p>
        </section>

        <section>
          <div className="flex items-center mb-3">
            <Bell size={20} className="text-primary-600 mr-2" />
            <h2 className="text-lg font-bold text-gray-900">用户权利</h2>
          </div>
          <p className="text-gray-600 leading-relaxed">
            您有权随时查看、修改或删除您的个人信息。如需操作，请联系客服。
            您也可以随时撤回授权，但可能影响服务的正常使用。
          </p>
        </section>

        <section>
          <div className="flex items-center mb-3">
            <Trash2 size={20} className="text-primary-600 mr-2" />
            <h2 className="text-lg font-bold text-gray-900">数据保留</h2>
          </div>
          <p className="text-gray-600 leading-relaxed">
            您的数据将在服务结束后保留180天，之后将进行安全删除。
            法律法规要求保留的数据除外。
          </p>
        </section>

        <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <p className="text-sm text-yellow-800">
            <strong>重要提示：</strong>
            本系统涉及就业匹配分析，可能存在就业歧视法律风险。
            所有匹配结果均标注"仅供参考"，不构成任何录取承诺。
          </p>
        </div>
      </motion.div>
    </div>
  )
}

export default PrivacyPage
